<template>
  <div class="avatar-header">
    <img :src="avatar">
    <div v-if="showTitle" class="title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
    name: 'AvatarHeader',
    props: {
        avatar: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
    },
    computed: {
        showTitle() {
            return !!this.title;
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar-header {
    position: relative;
    width: 100vw;
    height: 100vw;
}
img {
    width: 100%;
    height: 100%;
}
.title {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: 0 4vw;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    line-height: 11.5vw;
    box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarHeader.vue